import { render, staticRenderFns } from "./previewDetail.vue?vue&type=template&id=bbb4f6f4"
import script from "./previewDetail.vue?vue&type=script&lang=js"
export * from "./previewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports